import React from "react";
import { Typography } from "@mui/material";

/**
 * Optional tenant-specific legal body from storefront legal_pages.
 * Falls back to default i18n children when override is empty.
 */
const LegalPageBody = ({ customBody, children }) => {
  const text = (customBody || "").trim();
  if (!text) {
    return children;
  }
  return text.split(/\n\n+/).map((paragraph) => (
    <Typography key={paragraph.slice(0, 40)} paragraph sx={{ whiteSpace: "pre-line" }}>
      {paragraph.trim()}
    </Typography>
  ));
};

export default LegalPageBody;
